import { render } from "./EmployeeApprovedLiquidations.vue?vue&type=template&id=3524b87c"
import script from "./EmployeeApprovedLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedLiquidations.vue?vue&type=script&lang=js"

import "./EmployeeApprovedLiquidations.vue?vue&type=style&index=0&id=3524b87c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__